var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFlagRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F04438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 12.6667H21.0929C21.3911 12.6667 21.5402 12.6667 21.6274 12.7294C21.7035 12.7841 21.7531 12.8683 21.7639 12.9613C21.7764 13.068 21.704 13.1983 21.5592 13.459L20.6618 15.0743C20.6092 15.1689 20.583 15.2161 20.5727 15.2662C20.5636 15.3105 20.5636 15.3562 20.5727 15.4005C20.583 15.4505 20.6092 15.4978 20.6618 15.5923L21.5592 17.2077C21.704 17.4683 21.7764 17.5987 21.7639 17.7053C21.7531 17.7984 21.7035 17.8826 21.6274 17.9373C21.5402 18 21.3911 18 21.0929 18H16.3993C16.026 18 15.8393 18 15.6967 17.9273C15.5712 17.8634 15.4693 17.7614 15.4053 17.636C15.3327 17.4934 15.3327 17.3067 15.3327 16.9333V15.3333M10.666 22L10.666 10.6667M10.666 15.3333H16.266C16.6394 15.3333 16.8261 15.3333 16.9687 15.2607C17.0941 15.1968 17.1961 15.0948 17.26 14.9693C17.3327 14.8267 17.3327 14.64 17.3327 14.2667V11.0667C17.3327 10.6933 17.3327 10.5066 17.26 10.364C17.1961 10.2386 17.0941 10.1366 16.9687 10.0727C16.8261 10 16.6394 10 16.266 10H11.7327C11.3593 10 11.1726 10 11.03 10.0727C10.9046 10.1366 10.8026 10.2386 10.7387 10.364C10.666 10.5066 10.666 10.6933 10.666 11.0667V15.3333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFlagRed);
export default __webpack_public_path__ + "static/media/Active-Flag-red.147080d5e45c9a4383dd33403fd29876.svg";
export { ForwardRef as ReactComponent };